<ul class="list-group" style="margin-bottom: 0;">
	<ng-container *ngFor="let navigationLink of navigationLinks">
		<li style="border: 0;" class="list-group-item">
			<a [attr.href]="'#' + navigationLink.id + 'TicketComponent'">
				<span>{{navigationLink.text}}</span>
			</a>
		</li>
	</ng-container>
</ul>